var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"label",class:_vm.statusClass},[_c('img',{staticClass:"label__icon",attrs:{"src":_vm.statusIcon}}),_vm._v("\n\n    "+_vm._s(_vm.trans('domain.whois.private-status.' + _vm.status))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }